export const REPORTJOBS = 'REPORTJOBS'
export const FETCH = 'FETCH'
export const SETTIMEZONEDATA = 'SETTIMEZONEDATA'
